export default __webpack_public_path__ + "media/images/mailer/wordmark-f8fcd99b0f6fc53f7d08a509c3a0ec00.png";